<template>
    <section class="sponsors">
        <div class="container is-max-desktop no-indent">
            <h2>Tak til vores sponsorer</h2>
            <div class="list">
                <a
                    v-for="sponsor in sponsors"
                    :key="sponsor.id"
                    :href="sponsor.website"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img :src="sponsor.logo" :alt="sponsor.name">
                </a>
            </div>
        </div>
    </section>
</template>

<script>
import { defineComponent, ref, watch } from 'vue'
import { useComposition } from '@/compositions/composition'

function shuffle(list) {
  const items = [...list]
  for (let i = items.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[items[i], items[j]] = [items[j], items[i]]
  }
  return items
}

export default defineComponent({
  setup() {
    const { global } = useComposition()
    const sponsors = ref([])

    watch(
      () => global.value.sponsors,
      (list) => {
        sponsors.value = shuffle(Array.isArray(list) ? list : [])
      },
      { immediate: true }
    )

    return { sponsors }
  }
})
</script>
